import Tabs from 'antd/lib/tabs'

import 'antd/lib/tabs/style'

export * from 'antd/lib/tabs'

export default Tabs
